import styled from 'styled-components';

export default styled.div`
  font-size: 2rem;
  background: ${props => props.editable ? 'rgba(72, 53, 198, 0.2)' : 'none'};
  border: ${props => props.editable ? '1px dashed rgba(72, 53, 198, 1)' : 'none'};
  cursor: ${props => props.editable ? 'grab' : 'pointer'};
  width: fit-content;
  position: relative;
  user-select: none;
  height: ${props => props.height ? props.height : 'unset'};


  &:active { 
    cursor: ${props => props.editable ? 'grabbing' : 'pointer'};
  }

  ${props => props.editable ? `
  &::before {
    position: absolute;
    content: '🔗';
    display: flex;
    background: rgba(72, 53, 198, 0.3);
    text-align: center;
    z-index: 2;
    padding: 0.5rem;
    width: 100%;
    height: 100%;
    user-select: none;
}
  }` : 'none'};
  

  ${props => props.thisStyles}
`;
